import { action, computed, makeAutoObservable, observable, runInAction } from 'mobx';
import FirebaseStore from './firebaseStore';
import { AdminEmails } from '../utils/appConfig';


export enum IAuthStatus {
  UNKNOWN,
  SIGNEDIN,
  NOTSIGNEDIN
}

export class UserStore {
  listener: any;
  @observable userId?: string;
  @observable authStatus: IAuthStatus = IAuthStatus.UNKNOWN;

  constructor(private fireStore: FirebaseStore) {
    makeAutoObservable(this)

    this.listener = this.fireStore.onAuthUserListener(
      async (user: any) => {
        if (!user.emailVerified) {
          console.log('Email has not been verified');
          // this.logout();
          return;
        } else {
          this.authStatus = !!user ? IAuthStatus.SIGNEDIN : IAuthStatus.NOTSIGNEDIN;
          localStorage.setItem('authUser', JSON.stringify(this.firebaseUserToUserInfo(user)));
          runInAction(() => {
            this.userId = user.uid;
          });
        }
      },
      () => {
        this.authStatus = IAuthStatus.NOTSIGNEDIN;

        localStorage.removeItem('authUser');
        console.log("Remove userInfo - Listener");
        runInAction(() => {
          this.userId = undefined;
        });
      });
  }

  private firebaseUserToUserInfo = (fbUser: any) => {
    return {
      uid: fbUser.uid,
      username: fbUser.firstname + ' ' + fbUser.lastname,
      email: fbUser.email,
      photoURL: fbUser.providerData[0].photoURL,
      phoneNumber: fbUser.providerData[0].phoneNumber
    }
  }

  @computed
  get isAuthenticated() {
    return !!this.fireStore.authService.currentUser
  }

  @computed
  get isAuthReady() {
    return this.authStatus !== IAuthStatus.UNKNOWN;
  }

  @action
  login = async (email: string, password: string) => {
    console.log("Remove userInfo - Login");
    this.userId = undefined;
    localStorage.removeItem('authUser');

    if (!isAdmin(email)) {
      const err = { code: 'user-not-admin', message: 'You are not a designated admin' };
      throw err;
    }

    const cred = await this.fireStore.signInWithEmailAndPassword(email, password);
    if (!cred.user.emailVerified) {
      const err = { code: 'email-not-verified', message: 'Email address is not verified', user: cred.user };
      this.logout();
      throw err;
    }
  }

  @action
  logout = async () => {
    this.authStatus = IAuthStatus.NOTSIGNEDIN;
    localStorage.removeItem('authUser');
    this.userId = undefined;

    await this.fireStore.signOut();
  }
}

const isAdmin = (email: string) => AdminEmails.find(e => e.toLowerCase() === email.toLowerCase());